export const getTreeCheckedNodes = (checkedLocations) => {
  const locations = [];
  const facilitiesObj = {};

  const locsArr = checkedLocations.filter((node) => {
    if (node.levelName === 'facility') {
      facilitiesObj[node.facilityId] = true;
      locations.push(node.id);

      return false;
    }

    return true;
  });

  locsArr.forEach((node) => {
    if (!facilitiesObj[node.facilityId]) {
      locations.push(node.id);
    }
  });

  return locations;
};
